import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

export default function PurchaseMenues(props) {

  const handleChange = (event, newValue) => {
    props.handleChange(newValue)
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={props.filter?props.filter:'pending'}
        onChange={handleChange}
        textColor="secondary"
        variant='standard'
        indicatorColor="secondary"
        aria-label="secondary tabs example"
        
      >
        <Tab value={"All"} label="All" />
        <Tab value={"approved"} label="Approved" />
        <Tab value={"pending"} label="Pending" />
        {
          !props.route?
          <Tab value={"rejected"} label="Rejected" />
          :
          null
        }

      </Tabs>
    </Box>
  );
}
